import React from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Layout from '.'

const MainLayout = ({ children }) => {
    const location = useLocation()
    const isLoginPage = location?.pathname === "/admin/login"
    
    return (
        <Box>
            {isLoginPage ? children : <Layout children={children} />}
        </Box>
    )
}

export default MainLayout
